var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBabyTeeth({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 679,
    width: 1024,
    height: 1024,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 743.356c-185.968 0-336.724-150.756-336.724-336.724a29.988 29.988 0 0 1 29.988-29.988h613.472a29.988 29.988 0 0 1 29.988 29.988c0 185.968-150.756 336.724-336.724 336.724z",
    fill: "#FD919F",
    "p-id": 681
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M491.52 638.436h-67.176a20.48 20.48 0 0 0-20.48 20.48v66.592a336.096 336.096 0 0 0 108.14 17.848v-84.44a20.488 20.488 0 0 0-20.484-20.48z",
    fill: "#FFFFFF",
    "p-id": 682
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M620.14 658.916a20.48 20.48 0 0 0-20.48-20.48H532.48a20.48 20.48 0 0 0-20.48 20.48v84.44a336.116 336.116 0 0 0 108.14-17.848v-66.592z",
    fill: "#FFFFFF",
    "p-id": 683
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M491.52 638.436h-20.856v102.368c13.544 1.676 27.336 2.552 41.336 2.552v-84.44a20.48 20.48 0 0 0-20.48-20.48zM599.656 638.436H578.8v98.188a337.8 337.8 0 0 0 41.336-11.116v-66.592a20.48 20.48 0 0 0-20.48-20.48z",
    fill: "#D5E6F7",
    "p-id": 684
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M642.044 532.296h-99.66a30.384 30.384 0 0 1-30.384-30.384V376.644h160.424v125.268c0 16.78-13.6 30.384-30.38 30.384zM481.616 532.296H381.956a30.384 30.384 0 0 1-30.384-30.384V376.644H512v125.268a30.384 30.384 0 0 1-30.384 30.384z",
    fill: "#FFFFFF",
    "p-id": 685
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M459.712 376.644v125.268a30.384 30.384 0 0 1-30.384 30.384h52.288c16.78 0 30.384-13.6 30.384-30.384V376.644h-52.288zM620.14 376.644v125.268a30.384 30.384 0 0 1-30.384 30.384h52.288c16.78 0 30.384-13.6 30.384-30.384V376.644h-52.288z",
    fill: "#D5E6F7",
    "p-id": 686
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M481.616 544.292H381.956c-23.368 0-42.384-19.012-42.384-42.384V376.644a12 12 0 0 1 12-12H512a12 12 0 0 1 12 12v125.264c0 23.372-19.012 42.384-42.384 42.384z m-118.04-155.648v113.264a18.408 18.408 0 0 0 18.384 18.384h99.66a18.408 18.408 0 0 0 18.384-18.384V388.644H363.576z",
    fill: "#504774",
    "p-id": 687
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M642.044 544.292h-99.66c-23.372 0-42.384-19.012-42.384-42.384V376.644a12 12 0 0 1 12-12h160.424a12 12 0 0 1 12 12v125.264c0 23.372-19.008 42.384-42.38 42.384zM524 388.644v113.264a18.408 18.408 0 0 0 18.384 18.384h99.66a18.408 18.408 0 0 0 18.384-18.384V388.644H524zM512 755.36a348.056 348.056 0 0 1-111.992-18.488 12 12 0 0 1-8.148-11.364V658.92c0-17.912 14.572-32.48 32.48-32.48h67.176c17.912 0 32.48 14.572 32.48 32.48v84.44a11.992 11.992 0 0 1-11.996 12z m-96.14-38.572A324.004 324.004 0 0 0 500 731.136v-72.22c0-4.676-3.804-8.48-8.48-8.48h-67.176c-4.676 0-8.48 3.804-8.48 8.48v57.872z",
    fill: "#504774",
    "p-id": 688
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M512 755.36a12 12 0 0 1-12-12v-84.44c0-17.912 14.572-32.48 32.48-32.48h67.176c17.912 0 32.484 14.572 32.484 32.48v66.588a11.992 11.992 0 0 1-8.148 11.364A348.092 348.092 0 0 1 512 755.36z m20.48-104.924c-4.676 0-8.48 3.804-8.48 8.48v72.22a323.872 323.872 0 0 0 84.14-14.352v-57.868c0-4.676-3.804-8.48-8.484-8.48H532.48z",
    fill: "#504774",
    "p-id": 689
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M512 755.356c-192.288 0-348.724-156.436-348.724-348.724 0-23.152 18.836-41.988 41.988-41.988h613.472c23.156 0 41.992 18.836 41.992 41.988 0 192.284-156.44 348.724-348.728 348.724zM205.264 388.644a18.012 18.012 0 0 0-17.988 17.988c0 179.052 145.668 324.724 324.724 324.724s324.728-145.672 324.728-324.724a18.012 18.012 0 0 0-17.992-17.988H205.264z",
    fill: "#504774",
    "p-id": 690
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBabyTeeth);
export default __webpack_public_path__ + "static/media/babyTeeth.8c11bb020b3ecdc9bd147e69f3fd3f31.svg";
export { ForwardRef as ReactComponent };